export default {
  route: {
  },
  form: {
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js